var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAccordianMinus = function SvgAccordianMinus(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "remove_FILL0_wght400_GRAD0_opsz48",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 3,
    viewBox: "0 0 20 3",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "remove_FILL0_wght400_GRAD0_opsz48-2",
    "data-name": "remove_FILL0_wght400_GRAD0_opsz48",
    d: "M10,25.5v-3H30v3Z",
    transform: "translate(-10 -22.5)",
    fill: "#4d4c50"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAccordianMinus);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/accordian_minus.aa035d9e51dd78f83bf00105bb7268c5.svg";